var USER = 't_user';
var DSE_USER = 'dse_t_user';
var TOKEN = 't_token';
var APM_AUH_TOKEN = 't_apmAutnToken';
var LS_CACHE_KEYS = {
  USER: USER,
  DSE_USER: DSE_USER,
  TOKEN: TOKEN,
  APM_AUH_TOKEN: APM_AUH_TOKEN
};
export default LS_CACHE_KEYS;